import {Component, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AdminCard} from '../../Controlls/Sonstige/AdminCard';
import {DateSelect} from '../../../Akte/Controlls/DateSelect';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
  selector: 'abteilung',
  imports: [
    FormsModule,
    AdminCard,
    DateSelect
  ],
  templateUrl: './abteilung.html',
  styleUrl: './abteilung.css',
})
export class Abteilung {
  Name: string = "";
  modal = inject(NgbActiveModal);

  Send()
  {
    this.modal.close(this.Name);
  }
}
